import React, { useState } from 'react';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import { FaEdit, FaPlus } from "react-icons/fa";
import CompanyTableModalContent from '../ModalContent/CompanyTableModalContent';
import RouteModal from '../../../Component/BasicComponents/Modal/RouteModal';
import { useGetCompanyList } from './hook/useCompony';
 
const companyDataColumns = (handleEdit:(row:any)=>void)=> [ 
  {
    name: "ID",
    selector: (row: { CompanyId: string }) => row.CompanyId,
    sortable: true,
    width: "70px", 
  },
  {
    name: "Code",
    selector: (row: { CompanyCode: string }) => row.CompanyCode,
    sortable: true,
    // width: "100px",
    wrap:true
  },
  {
    name: "Name",
    selector: (row: { CompanyName: string }) => row.CompanyName,
    sortable: true,
    width: "120px", 
    wrap:true
  },
  {
    name: "Owner",
    selector: (row: { OwnerName: string }) => row.OwnerName,
    sortable: true,
    width: "110px",
    wrap:true

  },
  {
    name: "Email",
    selector: (row: { OwnerEmail: string }) => row.OwnerEmail,
    sortable: true,
    width: "200px",
    wrap:true
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <button
        onClick={()=>handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

 

const CompanyTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status,setStatus]  = useState<string|null>(null);
  const [rowData,setRowData]  = useState<any|null>(null)

  const [filterSate,setFilter] = useState({
    search:'',
    page:1,
    limit:10,
  })
  
   
   const{data,isLoading,isSuccess} = useGetCompanyList({enable:true,params:{
     page:filterSate.page,
     limit:filterSate.limit,
     search:filterSate.search 
   }})

  //  console.log('data=========>',data?.formatedData);

  const addCompanyHandler =()=>{
    setIsModalOpen(true);
    setStatus('Add');
  }
  const handleEdit=(row:any)=>{
        // console.log('row========>',row);
      setStatus('Edit');
      setIsModalOpen(true);
      setRowData(row);
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setStatus(null);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setStatus(null);
  };
   
  const handleSearch =(val:any)=>{
    setFilter((prev:any)=>({
          ...prev,
          search:val
    }))
  }
  
  const handlePagination =(pageNo:number)=>{
       setFilter((prev:any)=>({
          ...prev,
          page:pageNo
    }))
  }

  const handleonChangeRowsPerPage=(newPerPage:any,page:any)=>{
          setFilter((prev:any)=>({
          ...prev,
          page:page,
          limit:newPerPage
    }))
  }

   return (
    <div className="container mt-3">
      <BasicDataTable
        minHeightOfTable={570}
        paginationTotalRows={data?.RowData.data?.pagination?.total_records || 0}
        onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
                 handleonChangeRowsPerPage(newPerPage, page)
        }}
        handleSearch={(val: any) => {handleSearch(val) }}

        Title="Company"
        data={(!isLoading && isSuccess && data.formatedData)||[]}
        columns={companyDataColumns(handleEdit)}
        headerContent={
          <div style={{marginRight:'10px'}}> 
          <button
            onClick={()=>addCompanyHandler()}
            className="btn btn-info"
            style={{  
               maxWidth:'160px',
              borderRadius: "20px",
              // padding: "4px 10x",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <FaPlus /><span>Add Company</span>
          </button>
          </div>
        }
      />
      <RouteModal
        toggle={toggleModal}
        isOpen={isModalOpen}
        title={status ==='Add'? "Add Company" :"Update Company"}
        size="lg"
        content={
          <CompanyTableModalContent
            handleClose={handleClose}
            status={status}
            rowData={rowData}
          />
        }
      />
    </div> 
  );
};

export default CompanyTable;
